import CryptoJS from "crypto-js";
import dsBridge from "dsbridge";
import {
    getDeviceType
} from "@/utils/getDeviceType";
const username = 'imlink'
const secretKey = "uW8e7rjjWeuZL39P7swZNHvTV3uoePKR"

export const getParams = async function () {
    const timeStamp = Date.now();
    var params = {
        'Content-Type': 'application/json; charset=utf-8',
        // @ts-ignore
        'x-date': new Date(timeStamp).toGMTString(),
        'x-nonce': uuid(),
        'x-timestamp': timeStamp.toString()
    }
    var signature = genSignature(`x-date: ${params['x-date']}\nx-nonce: ${params['x-nonce']}\nx-timestamp: ${params['x-timestamp']}`, secretKey)
    var authorization = `hmac username="${username}", algorithm="hmac-sha256",headers="x-date x-nonce x-timestamp", signature="${signature}"`;
    return new Promise((resolve) => {
        var data = {
            'x-date': params['x-date'],
            'x-nonce': params['x-nonce'],
            'x-timestamp': params['x-timestamp']
        }
        // console.log('dataSign-param', JSON.stringify(data), getDeviceType())
        if (getDeviceType() == 'unknown') {
            params['authorization'] = authorization
            resolve(params)
        } else {
            dsBridge.call('dataSign', data, res => {
                // console.log('dataSign-authorization', res)
                let data = typeof res === "string" ? JSON.parse(res) : res
                // var authorization = `hmac username="${username}", algorithm="hmac-sha256",headers="x-date x-nonce x-timestamp", signature="${res}"`;
                params['authorization'] = data.authorization
                resolve(params)
            })
        }

    })
}
export const uuid = function () {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4";
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
    s[8] = s[13] = s[18] = s[23] = "-";
    var uuid = s.join("");
    return uuid
}

export const genSignature = function (str, secretKey) {
    return CryptoJS.enc.Base64.stringify(CryptoJS.HmacSHA256(str, secretKey))
}